import states from './states';

export default function(appModule) {
  appModule.config(states);
}
